import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { PageDisplayer, FoldingPanel } from '../../../../ui'
import { useJCAContext, JCAForm, JCAEventsTable } from '../../../../features/jca'

export const JCADetailPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { jcaId } = useParams()
  const { formatMessage } = useIntl()
  const { detailLoading, detailError, getJCA } = useJCAContext()

  useEffect(() => {
    getJCA(jcaId)
  }, [jcaId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/jca' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={detailLoading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.jca.detail.goBack' })}
    >
      {detailError ? (
        formatMessage({ id: 'pages.jca.detail.error' })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {formatMessage({ id: 'pages.jca.detail.title' })}
            </Typography>
          </Box>
          <Box mb={2}>
            <JCAForm />
          </Box>
          <FoldingPanel
            isExpanded={true}
            title={formatMessage({ id: 'pages.jca.detail.events.title' })}
          >
            <JCAEventsTable />
          </FoldingPanel>
        </>
      )}
    </PageDisplayer>
  )
}
